import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useValidatePassword = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IValidatePasswordRequestData) => {
        return await send({
            ID: 35574,
            responses: [35575, 35576],
            description: 'Validate Password',
            errorLevel: 1,
            ...request
        });
    }, [send]);
};
